import { useEffect } from 'react';
// next
// @mui
import { Container, Grid, Pagination, Stack, Typography } from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
// utils
// routes
// layouts
import Layout from '../../layouts';
// components
import Page from '../../components/Page';
import { SkeletonPostItem } from '../../components/skeleton';
import useLocales from '../../hooks/useLocales';
import { useDispatch, useSelector } from '../../redux/store';
// sections
import { styled } from '@mui/material/styles';
import EmptyContent from '../../components/EmptyContent';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { getPosts, setPostSearch } from '../../redux/slices/blog/blog.post';
import { PATH_PAGE, PATH_RESOURCE } from '../../routes/paths';
import { BlogPostCard } from '../../sections/blog/post';
import BlogPostTableToolbar from '../../sections/blog/post/BlogPostTableToolbar';

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
}));

// ----------------------------------------------------------------------

Index.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function Index() {
  const { translate } = useLocales();
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();

  const { posts, search, isLoading, totalPages, numberOfElements } = useSelector((state) => state.blogPost);

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getPosts());
    }, 500);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleChangePage = (_, page) => {
    dispatch(setPostSearch({ ...search, page: page - 1, }));
  };

  return (
    <Page title={translate('blog.title')} description={translate('blog.description')}>
      <RootStyle>
        <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
          <HeaderBreadcrumbs
            links={[
              { name: translate("menu.hackerthon"), href: PATH_PAGE.home },
              { name: translate("menu.blog"), href: PATH_RESOURCE.blogs }
            ]}
          />
          <Grid container spacing={1} >
            <Grid item xs={12} md={12}>
              <Typography variant="h5">{translate("blog.title")}</Typography>
              <BlogPostTableToolbar />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            {posts.map((post, index) => (
              <Grid key={post.id} item xs={12} sm={6} md={(index === 0 && 6) || 3}>
                <BlogPostCard post={post} index={index} />
              </Grid>
            ))}
            <Grid item xs={12}>
              {isLoading ? <SkeletonPostItem /> :
                numberOfElements == 0 && <EmptyContent description={translate("hackerthon.exercise.noSolution")} />}

              <Stack alignItems={"center"} my={1.5}>
                <Pagination count={totalPages} variant='text' page={search.page + 1} onChange={handleChangePage} />
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page>
  );
}
